.ax{padding:0.5rem;}